import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { Box } from '@atlaskit/primitives';
import React, { useEffect, useRef, useState } from 'react';
export var MotionWrapper = function MotionWrapper(_ref) {
  var children = _ref.children,
    _ref$isFadeIn = _ref.isFadeIn,
    isFadeIn = _ref$isFadeIn === void 0 ? false : _ref$isFadeIn,
    _ref$minHeight = _ref.minHeight,
    minHeight = _ref$minHeight === void 0 ? 0 : _ref$minHeight,
    show = _ref.show,
    _ref$showTransition = _ref.showTransition,
    showTransition = _ref$showTransition === void 0 ? false : _ref$showTransition;
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    height = _useState2[0],
    setHeight = _useState2[1];
  var ref = useRef(null);
  var transition = isFadeIn ? 'height, opacity' : 'height';
  useEffect(function () {
    if (show && ref.current) {
      // set the height of the error message container explicitly to the height
      // of its contents (including anything hidden due to overflow) so that we
      // can animate the height of the container
      setHeight(ref.current.scrollHeight);
    } else {
      setHeight(0);
    }
  }, [children, show]);
  return show ? /*#__PURE__*/React.createElement(Box, {
    style: {
      height: height,
      minHeight: minHeight,
      // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
      lineHeight: 0,
      // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
      overflow: 'hidden',
      // a fit for purpose state variable to control when the 'visible' styles should be appled
      opacity: height > 0 ? 1 : 0,
      // we only want to transition opacity and height when the error message is initially shown
      // not if its to be shown on mount
      transitionProperty: showTransition ? transition : 'none',
      // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
      transitionDuration: '0.3s'
    },
    ref: ref
  }, children) : null;
};
export default MotionWrapper;